import AdminLogin from "Pages/NoAuth/AdminLogin";
import ChangePassword from "Pages/NoAuth/ChangePassword";
import ForgotPassword from "Pages/NoAuth/ForgotPassword";
import ProjectFile from "Pages/NoAuth/ProjectFile";
import ProjectValidation from "Pages/NoAuth/ProjectValidation";
import SelectivePresentation from "Pages/NoAuth/SelectivePresentation";

// ⚠️ `allowAuthenticated` (11/08/2026): rota pública que NÃO expulsa quem está
// logado.
//
// O NoAuthLayout redireciona todo usuário autenticado para o dashboard, o que é
// certo para as telas de LOGIN e de senha (quem já entrou não tem o que fazer
// nelas) e errado para as três páginas abertas por TOKEN — o proponente que
// recebe o e-mail de validação e o patrocinador que abre o book pela
// apresentação normalmente estão logados, e caíam na home sem entender por quê.
// Nos testes E2E o problema não aparecia: as páginas por token só eram
// exercitadas em contexto ANÔNIMO.
const NoAuthRoutes = {
  AdminLogin: {
    path: "/admin",
    element: AdminLogin,
    noPadding: true,
    noHeader: true,
  },
  AdminChangePassword: {
    path: "/admin/change-password",
    element: ChangePassword,
    noPadding: true,
    noHeader: true,
  },
  ForgotPassword: {
    path: "/forgot-password",
    element: ForgotPassword,
    noPadding: true,
    noHeader: true,
  },
  // Resposta do proponente ao e-mail de validação: pública de propósito — a
  // autorização vem do token assinado na URL, sem exigir login.
  ProjectValidation: {
    path: "/validacao-projeto",
    element: ProjectValidation,
    noPadding: true,
    noHeader: true,
    allowAuthenticated: true,
  },
  // Book de captação aberto pelo link da APRESENTAÇÃO da seletiva: pública
  // porque o .pptx circula fora da plataforma — a autorização é o token da URL.
  ProjectFile: {
    path: "/arquivo-projeto",
    element: ProjectFile,
    noPadding: true,
    noHeader: true,
    allowAuthenticated: true,
  },
  // Apresentação da seletiva aberta pelo link do e-mail enviado ao
  // patrocinador: pública porque o link vale 3 meses e não pede login.
  SelectivePresentation: {
    path: "/apresentacao-seletiva",
    element: SelectivePresentation,
    noPadding: true,
    noHeader: true,
    allowAuthenticated: true,
  },
  // Register: {
  //   path: "/register",
  //   element: Register,
  //   noPadding: true,
  //   noHeader: true,
  // },
};

export default NoAuthRoutes;
